module.exports = __webpack_public_path__ + "img/linkedin-l.351c9665.svg";